{
  "commonHeader": {
    "toggleSidebar": "切換側邊欄",
    "cartLoading": "購物車載入中",
    "cart": "購物車",
    "aicForAdmin": {
      "ariaLabel": "管理員 AI"
    },
    "usersResults": "使用者，{0} 筆結果",
    "settingsResults": "設定，{0} 筆結果",
    "navigationResults": "導覽，{0} 筆結果",
    "learnMoreAbout": "深入瞭解 {0}",
    "close": "關閉",
    "products": "產品",
    "moreActions": "更多操作",
    "search": "搜尋",
    "searchPlaceholderAll": "搜尋使用者、帳戶設定或導覽",
    "searchPlaceholderUsers": "搜尋使用者或導覽",
    "searchPlaceholderSettings": "搜尋帳戶設定或導覽",
    "searchPlaceholderNav": "搜尋導覽"
  },
  "footerCopyright": {
    "language": "語言 {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "管理員選單"
    }
  },
  "shared": {
    "close": "關閉",
    "sideMenu": {
      "personalAria": "個人選單",
      "adminAria": "管理員選單",
      "mainNav": "主導覽",
      "submenu": "子選單",
      "pinnedSection": "{0}已釘選",
      "sideMenuAria": "側邊選單",
      "pinItem": "釘選 {0}",
      "unpinItem": "取消釘選 {0}",
      "reorderGrabbed": "正在重新排序 {0}，已抓取。使用上下箭頭鍵移動，按空格或 Enter 放下，按 Esc 取消。",
      "reorderIdle": "重新排序 {0}。按空格或 Enter 抓取。",
      "hintHandlePin": "按 Tab 鍵存取拖曳控點和釘選按鈕",
      "hintHandle": "按 Tab 鍵存取拖曳控點",
      "hintPin": "按 Tab 鍵存取釘選按鈕",
      "upgradeToPro": "升級至專業版"
    },
    "item": "項目"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "體驗新介面"
    }
  },
  "aicGuide": {
    "common": {
      "close": "關閉"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "分區現已可用"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "管理外部帳戶"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "通訊錄將更名為客戶目錄"
    }
  },
  "feedback": {
    "itemLableForProductArea": "產品領域",
    "itemLableForFeedback": "意見反應"
  }
}
